import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'website-klaxoon-logo',
    standalone: true,
    templateUrl: './klaxoon-logo.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'header-logo__image' },
})
export class KlaxoonLogoComponent {
    @Input() isDarkTheme = false;
}
